import React from 'react'

import PropTypes from 'prop-types'
import {
  CustomerDetail,
  DetailsContainer,
  Text,
  Card,
  Star,
  LogoContainer,
  ReviewerDetails,
  SocialText,
  StarContainer,
} from './styles'

export default function LPTestimonialCard(props) {
  const { text, image, name, location, household, starRating, useStars } = props
  const stars = Array.from({ length: starRating }, (_, i) => (
    <Star
      key={i}
      src="https://cdn.builder.io/api/v1/image/assets%2Fb0fdb13eaaac4a18820508d774ca5eba%2F027f2afd135fa5838365bc7cba5887a57aa31413"
      alt="Star rating"
    />
  ))

  return (
    <Card id="card">
      {useStars && <StarContainer>{stars}</StarContainer>}

      <Text className="text">
        <SocialText id="social">{text}</SocialText>
      </Text>

      <ReviewerDetails>
        <>
          <LogoContainer id="logo">
            <img src={image} alt="Happy Customer" />
          </LogoContainer>
          <DetailsContainer>
            <CustomerDetail id="customer">{name}</CustomerDetail>
            <CustomerDetail id="customer">{`${household} ${location}`}</CustomerDetail>
          </DetailsContainer>
        </>
      </ReviewerDetails>
    </Card>
  )
}

LPTestimonialCard.propTypes = {
  text: PropTypes.string,
  name: PropTypes.string,
  image: PropTypes.string,
  location: PropTypes.string,
  household: PropTypes.string,
  starRating: PropTypes.number,
  useStars: PropTypes.bool,
}
